import ScreenContainer from '../display/ui/ScreenContainer';
import TwoPlayersModel from '../model/TwoPlayersModel';
import ButtonSimple from '../ui/buttons/ButtonSimple';
import AnimalIcon from '../ui/AnimalIcon';
import StarBurst from '../ui/StarBurst';
import TwoPlayersOnboardingController from '../controller/TwoPlayersOnboardingController';
import ElinorForward from '../ui/ElinorForward';
import { STATE_LEVEL_TWO_PLAYERS } from '../constants/StateConstants';

export default class TwoPlayersSetup extends Phaser.State {
  init({ levelData, seekerId }) {
    this.levelData = levelData;
    this.seekerId = seekerId;

    this.availableIcons = ['olive', 'ari', 'koa', 'elinor'];
  }

  preload() {}

  create() {
    // prepare captions
    this.game.twoPlayersOnboarding = new TwoPlayersOnboardingController(this.game);

    // create players data model
    this.twoPlayersModel = new TwoPlayersModel();

    //
    this.container = new ScreenContainer(this.game, {
      title: '',
    });

    // create background according the location
    const bg = this.game.make.image(0, 0, 'bg_location_' + this.game.controller.location);
    bg.width = this.game.defaultWidth;
    bg.height = this.game.defaultHeight;
    this.container.addChild(bg);

    // show player buttons
    this.createPlayerButtons();

    // elinor
    this.elinor = new ElinorForward(this.game);
    this.elinor.y = this.game.defaultHeight;
    this.container.addChild(this.elinor);

    // positioning
    this.game.scale.onSizeChange.add(this.handleResize, this);
    this.handleResize();

    //
    this.playInitialAnim();

    // transition
    this.transition = this.game.controller.getTransition();
    this.transition.fadeOut();
  }

  playInitialAnim() {
    // voice overs
    this.game.twoPlayersOnboarding.playVOs(['ob_05_elinor_001', 'ob_05_elinor_002'], this.elinor);
    this.game.twoPlayersOnboarding.onEnd.addOnce(this.showPlayerButtons, this);

    this.emptyPlayer1.scale.set(0);
    this.game.add
      .tween(this.emptyPlayer1.scale)
      .to({ x: 1, y: 1 }, 300, Phaser.Easing.Back.Out, true);
    this.emptyPlayer2.scale.set(0);
    this.game.add
      .tween(this.emptyPlayer2.scale)
      .to({ x: 1, y: 1 }, 300, Phaser.Easing.Back.Out, true, 100);
  }

  handleResize() {
    this.elinor.x = this.game.defaultWidth - (this.game.defaultWidth - this.game.width) * 0.5 - 200;
  }

  createPlayerButtons() {
    this.playerButtons = this.game.make.group();
    this.container.addChild(this.playerButtons);

    const x0 = this.game.defaultWidth / 2;
    const y0 = this.game.defaultHeight / 2;

    // empty icons
    this.emptyPlayer1 = this.game.make.image(x0 - 145, y0, 'ui_player_mode', 'btn_player1_empty');
    this.emptyPlayer1.anchor.set(0.5);
    this.emptyPlayer2 = this.game.make.image(x0 + 145, y0, 'ui_player_mode', 'btn_player2_empty');
    this.emptyPlayer2.anchor.set(0.5);

    // buttons
    this.btnPlayer1 = new ButtonSimple({
      game: this.game,
      up: 'btn_player1',
      over: 'btn_player1',
    });
    this.btnPlayer1.position.set(x0 - 145, y0 + 5);
    this.btnPlayer1.onInputDown.add(this.handleBtnPlayer, this);
    this.btnPlayer1.disable();

    this.btnPlayer2 = new ButtonSimple({
      game: this.game,
      up: 'btn_player2',
      over: 'btn_player2',
    });
    this.btnPlayer2.position.set(x0 + 145, y0 + 5);
    this.btnPlayer2.onInputDown.add(this.handleBtnPlayer, this);
    this.btnPlayer2.disable();

    // arrow
    this.arrow = this.game.make.image(0, 0, 'ui_various', 'arrow_pointing_dr');
    this.arrow.anchor.set(1);

    //
    this.playerButtons.addChild(this.emptyPlayer1);
    this.playerButtons.addChild(this.emptyPlayer2);
    this.playerButtons.addChild(this.btnPlayer1);
    this.playerButtons.addChild(this.btnPlayer2);
    this.playerButtons.addChild(this.arrow);

    // hide elements
    this.btnPlayer1.visible = false;
    this.btnPlayer2.visible = false;
    this.arrow.visible = false;
  }

  /* eslint-disable max-statements */
  showPlayerButtons() {
    if (!this.playerButtons) {
      this.createPlayerButtons();
    }
    this.playerButtons.visible = true;

    let btnLeft = this.btnPlayer1;
    let btnRight = null; // this.emptyPlayer2;
    this.arrow.visible = false;

    //
    if (!this.twoPlayersModel.playerIcon1) {
      // player 1 selects icon
      this.emptyPlayer1.visible = false;
      this.btnPlayer1.visible = true;
      this.btnPlayer1.enable();

      //
      const voID = this.game.device.desktop ? 'ob_05_elinor_003_click' : 'ob_05_elinor_003_tap';
      this.game.twoPlayersOnboarding.playVOs([voID], this.elinor);

      //
      this.showArrow(this.btnPlayer1);
    } else if (!this.twoPlayersModel.playerIcon2) {
      // player 2 selects icon
      this.iconPlayer1 = new AnimalIcon(
        this.game,
        this.btnPlayer1.x,
        this.btnPlayer1.y,
        1,
        this.twoPlayersModel.playerIcon1
      );
      this.playerButtons.addChild(this.iconPlayer1);

      //
      this.btnPlayer1.visible = false;
      this.btnPlayer1.disable();
      this.btnPlayer2.visible = true;
      this.btnPlayer2.enable();
      this.emptyPlayer2.visible = false;

      //
      btnLeft = this.iconPlayer1;
      btnRight = this.btnPlayer2;

      //
      this.game.twoPlayersOnboarding.playVOs(['ob_05_elinor_007'], this.elinor);

      //
      this.showArrow(this.btnPlayer2);
    } else {
      // both icons selected
      this.iconPlayer2 = new AnimalIcon(
        this.game,
        this.btnPlayer2.x,
        this.btnPlayer2.y,
        2,
        this.twoPlayersModel.playerIcon2
      );
      this.playerButtons.addChild(this.iconPlayer2);

      //
      this.btnPlayer2.visible = false;
      this.btnPlayer2.disable();

      //
      btnLeft = this.iconPlayer1;
      btnRight = this.iconPlayer2;

      //
      // this.game.time.events.add(1500, this.loadLevel, this);
      this.transition.onFadeEnd.addOnce(this.loadLevel, this);
      this.transition.fadeIn();
    }

    // animations
    btnLeft.scale.set(0);
    this.game.add.tween(btnLeft.scale).to({ x: 1, y: 1 }, 300, Phaser.Easing.Back.Out, true);
    if (btnRight) {
      btnRight.scale.set(0);
      this.game.add
        .tween(btnRight.scale)
        .to({ x: 1, y: 1 }, 300, Phaser.Easing.Back.Out, true, 100);
    }
  }
  /* eslint-enable*/

  showArrow(btn) {
    this.arrow.visible = true;
    const x1 = btn.x - 80;
    const y1 = btn.y - 110;
    this.arrow.x = x1 - 20;
    this.arrow.y = y1 - 20;
    this.arrow.alpha = 0;
    this.game.add.tween(this.arrow).to({ alpha: 1, x: x1, y: y1 }, 300, null, true);
  }

  handleBtnPlayer() {
    this.playerButtons.visible = false;

    this.showIcons();
  }

  showIcons() {
    this.iconsGroup = this.game.make.group();
    this.container.addChild(this.iconsGroup);

    // create buttons
    const len = this.availableIcons.length;
    const offsets = [
      [{ dx: -115, dy: -115 }, { dx: 115, dy: -115 }, { dx: 0, dy: 115 }],
      [{ dx: -115, dy: -115 }, { dx: 115, dy: -115 }, { dx: -115, dy: 115 }, { dx: 115, dy: 115 }],
    ];
    const offset = offsets[len - 3];
    const x0 = this.game.defaultWidth / 2;
    const y0 = this.game.defaultHeight / 2;

    this.iconBtns = [];
    for (let i = 0; i < len; i++) {
      const key = 'btn_icon_' + this.availableIcons[i];
      const btnIcon = new ButtonSimple({
        game: this.game,
        up: key,
        over: key,
        atlas: 'ui_player_mode',
      });
      btnIcon.position.set(x0 + offset[i].dx, y0 + offset[i].dy);
      btnIcon.id = this.availableIcons[i];
      btnIcon.onInputDown.add(this.handleIconDown, this);
      this.iconsGroup.addChild(btnIcon);
      this.iconBtns.push(btnIcon);

      const icon = this.game.make.image(
        -10,
        -20,
        'ui_player_mode',
        'icon_' + this.availableIcons[i]
      );
      icon.anchor.set(0.5);
      btnIcon.addChild(icon);

      // animate
      btnIcon.scale.set(0);
      this.game.add
        .tween(btnIcon.scale)
        .to({ x: 1, y: 1 }, 300, Phaser.Easing.Back.Out, true, 100 * i);
    }

    //
    this.game.twoPlayersOnboarding.playVOs(['ob_05_elinor_004'], this.elinor);
  }

  handleIconDown(btn) {
    if (!this.twoPlayersModel.playerIcon1) {
      this.twoPlayersModel.playerIcon1 = btn.id;
      const ind = this.availableIcons.indexOf(btn.id);
      this.availableIcons.splice(ind, 1);
    } else {
      this.twoPlayersModel.playerIcon2 = btn.id;
    }

    //
    for (let i = 0; i < this.iconBtns.length; i++) {
      const icon = this.iconBtns[i];
      icon.disable();
      if (icon === btn) {
        // enlarge
        icon.scale.set(0.7);
        this.game.add.tween(icon.scale).to({ x: 1.1, y: 1.1 }, 300, Phaser.Easing.Back.Out, true);
        this.starBurst = new StarBurst(this.game, 90, 120, 1);
        this.starBurst.x = icon.x;
        this.starBurst.y = icon.y;
        this.iconsGroup.addChild(this.starBurst);
      } else {
        // shrink
        this.game.add.tween(icon.scale).to({ x: 0, y: 0 }, 200, Phaser.Easing.Back.In, true);
      }
    }

    // this.game.time.events.add(1000, this.hideIcons, this);
    if (this.twoPlayersModel.playerIcon2) {
      // for player 2
      this.game.twoPlayersOnboarding.playVOs(
        ['ob_05_elinor_009', 'ob_05_elinor_' + this.twoPlayersModel.playerIcon2],
        this.elinor
      );
    } else {
      // for player 1
      this.game.twoPlayersOnboarding.playVOs(
        ['ob_05_elinor_006', 'ob_05_elinor_' + this.twoPlayersModel.playerIcon1],
        this.elinor
      );
    }
    this.game.twoPlayersOnboarding.onEnd.addOnce(this.hideIcons, this);
  }

  hideIcons() {
    // remove icons
    this.iconsGroup.destroy();
    this.iconsGroup = null;
    this.iconBtns = null;

    // display player buttons
    this.showPlayerButtons();
  }

  loadLevel() {
    //
    this.game.controller.twoPlayersModel = this.twoPlayersModel;

    //
    this.game.controller.startState(STATE_LEVEL_TWO_PLAYERS, {
      levelData: this.levelData,
      seekerId: this.twoPlayersModel.getSeekingPlayerIcon(),
    });
  }

  update() {}

  shutdown() {
    this.game.scale.onSizeChange.remove(this.handleResize, this);

    this.btnPlayer1.destroy();
    this.btnPlayer2.destroy();
    this.playerButtons.destroy();
    this.container.destroy();

    this.btnPlayer1 = null;
    this.btnPlayer2 = null;
    this.iconBtns = null;
    this.playerButtons = null;
    this.iconsGroup = null;
    this.elinor = null;
    this.container = null;
  }
}
